module.exports = __webpack_public_path__ + "static/media/graySocial.ff0902dd.svg";